import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";

type CircleHandleProps = {
  type?: "target" | "source";
  position?: Position;
  width?: number;
  height?: number;
};

function CircleHandle({ type, position, width, height }: CircleHandleProps) {
  return (
    <Handle
      type={type ?? "target"}
      position={position ?? Position.Left}
      className="!h-3 !w-3 !rounded-full !border-2 !border-white !bg-teal-500"
    />
  );
}

export default memo(CircleHandle);
